import { render, staticRenderFns } from "./ApproveRechargeWithdraw.vue?vue&type=template&id=7b675f6a&scoped=true&"
import script from "./ApproveRechargeWithdraw.vue?vue&type=script&lang=js&"
export * from "./ApproveRechargeWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./ApproveRechargeWithdraw.vue?vue&type=style&index=0&id=7b675f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b675f6a",
  null
  
)

export default component.exports